import React from "react";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { FluentButton } from "../../../../../../components/FluentUI/Fluent-Button";
import PropTypes from "prop-types";
import { FluentDialog2 } from "../../../../../../components/FluentUI/Fluent-Dialog2";

export const DeleteDialog = ({ identifier, open, OnCancel, OnDelete }) => {
  return (
    <FluentDialog2 open={open}>
      <div className="task-type-dialog-title">
        <p>{`Delete this ${identifier}?`}</p>
        <p onClick={OnCancel}>
          <FluentUiIcon name={"DismissRegular"} color={"#212121"} size={20} />
        </p>
      </div>
      <div className="task-type-dialog-content">
        <p>{`Are you sure you want to delete this ${identifier}?`}</p>
        <p>
          {`All the In-Form Automations, Form Actions, and Rules associated with
            this ${identifier} will all be impacted.`}
        </p>
      </div>
      <div >
         
      </div>
      <div className="task-type-dialog-footer">
        <FluentButton
          onClick={OnCancel}
          text={"Cancel"}
          backgroundColor={"#0F6CBD"}
        />
        <FluentButton
          onClick={OnDelete}
          appearance="primary"
          text="Delete"
          className="fluent-delete-btn"
        />
      </div>
    </FluentDialog2>
  );
};

DeleteDialog.propTypes = {
  identifier: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  OnCancel: PropTypes.func.isRequired,
  OnDelete: PropTypes.func.isRequired,
};
